module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2Ny40MyAxNDAuNTgiPjx0aXRsZT5mYl9pY29uPC90aXRsZT48cGF0aCBkPSJNNDIuNiwxNDAuNThIMTcuNTJWNzUuMTVIMHYtMjRIMTcuMzVjMC03LjQyLS4wOC0xNC41LDAtMjEuNTguMi0xMy43NSw4LjA3LTI0LjY1LDIxLjU4LTI3LjQyQzQ4LjA2LjI2LDU3LjY0LjY1LDY3LjQzLDBWMjMuMmMtNC45MSwwLTkuNDktLjA2LTE0LjA4LDAtOC42NS4xMy0xMC45MiwyLjQ1LTEwLjkzLDExLDAsNSwwLDEwLDAsMTVhMTIuNzcsMTIuNzcsMCwwLDAsLjMsMS41OUg2Ny4zNVY3NC43Nkg0Mi42WiIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/fb_icon.svg
// module id = U9A3
// module chunks = 1